import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useAppStore } from '@/stores/app';
import { onClickMenu } from '@/utils/router';
export default {
  __name: 'MenuTree',
  props: ['menus'],
  setup(__props) {
    const props = __props;
    const app = useAppStore();
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_menu_tree = _resolveComponent("menu-tree", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menus, menu => {
        return _openBlock(), _createElementBlock(_Fragment, null, [menu.children && menu.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          index: menu.path,
          key: menu.path
        }, {
          title: _withCtx(() => {
            var _menu$meta, _menu$meta2, _menu$meta3, _menu$meta4;
            return [_createVNode(_component_Icon, {
              name: (_menu$meta = menu.meta) !== null && _menu$meta !== void 0 && _menu$meta.icon ? (_menu$meta2 = menu.meta) === null || _menu$meta2 === void 0 ? void 0 : _menu$meta2.icon : _unref(app).menuDefaultIcon
            }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString((_menu$meta3 = menu.meta) !== null && _menu$meta3 !== void 0 && _menu$meta3.title ? (_menu$meta4 = menu.meta) === null || _menu$meta4 === void 0 ? void 0 : _menu$meta4.title : '无标题'), 1)];
          }),
          default: _withCtx(() => [_createVNode(_component_menu_tree, {
            menus: menu.children
          }, null, 8, ["menus"])]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          index: menu.path,
          key: menu.path,
          onClick: $event => _unref(onClickMenu)(menu)
        }, {
          default: _withCtx(() => {
            var _menu$meta5, _menu$meta6, _menu$meta7, _menu$meta8;
            return [_createVNode(_component_Icon, {
              name: (_menu$meta5 = menu.meta) !== null && _menu$meta5 !== void 0 && _menu$meta5.icon ? (_menu$meta6 = menu.meta) === null || _menu$meta6 === void 0 ? void 0 : _menu$meta6.icon : _unref(app).menuDefaultIcon
            }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString((_menu$meta7 = menu.meta) !== null && _menu$meta7 !== void 0 && _menu$meta7.title ? (_menu$meta8 = menu.meta) === null || _menu$meta8 === void 0 ? void 0 : _menu$meta8.title : '无标题'), 1)];
          }),
          _: 2
        }, 1032, ["index", "onClick"]))], 64);
      }), 256);
    };
  }
};